import type { ChartPattern, ChartTone } from "./frame.tsx";
import { patternAt, toneAt } from "./frame.tsx";

/** One series of a multi-series chart, in legend order. */
export interface ChartSeries {
  key: string;
  label: string;
  /** Defaults to the series' position (`--chart-1` first). */
  tone?: ChartTone;
}

/** One day or category with a value per series key (missing keys count as 0). */
export interface SeriesDatum {
  label: string;
  values: Readonly<Record<string, number>>;
}

export interface ResolvedSeries extends ChartSeries {
  tone: ChartTone;
  pattern: ChartPattern;
}

export function resolveSeries(series: readonly ChartSeries[]): ResolvedSeries[] {
  return series.map((s, i) => ({ ...s, tone: s.tone ?? toneAt(i), pattern: patternAt(i) }));
}
